const faqConstants = {
    defaultFAQs: [
        {
            question: 'What is oil analysis and what are the benefits of doing it?',
            answer: `
            <p>Oil analysis is a relatively inexpensive and simple way to help monitor oil condition and equipment condition while possibly preventing big problems from showing up down the road.</p>
            <p>During an oil analysis, a small amount of oil is analyzed for additive elements and contaminant and wear metals. The oil is also tested for its physical characteristics, such as viscosity, and for chemical properties, such as TAN. The results of these tests can give the user an indication of the condition of both the oil and the equipment. The main purpose of oil analysis is to generate information about the condition of the lubricant and the equipment. This information can be used to:</p>
            <ul>
                <li>Reduce unscheduled downtime - Oil Analysis can cut down on unscheduled equipment downtime and maintenance costs by spotting equipment problems before they become serious and costly to fix. </li>
                <li> Extend drain intervals - Regular testing allows the user to monitor the oil's condition. By knowing the condition of the oil, the user can make informed decisions about how long it can remain useful. </li>
                <li>Increase equipment life - Oil analysis can provide detailed information about the condition of the equipment, such as the wear levels and contamination. By detecting problems early, oil analysis allows the user to address problems early and extend equipment life.</li>
            </ul>
            `,
            weight: 3
        },
        {
            question: 'What is Trend Analysis and why is trending important?',
            answer: `
            <p>Trend Analysis is based on current and past sample results where changes in the tested result can indicate the development of problems that can affect the lubricant and compressor performance. The result may be within the products specifications. Trend Analysis plays an important role in determining proper drain intervals as well as in predicting equipment failure.</p>
            `,
            weight: 2.5
        },
        {
            question: 'What does &#147;marginal&#148; mean?',
            answer: `
            <p>Marginal means that the results are still within specifications but are close to the condemning limits.</p>
            `,
            weight: .5
        },
        {
            question: 'How much oil sample do you need to test?',
            answer: `
            <p>Four ounces is need for routine oil analysis. </p>
            `,
            weight: .5
        },
        {
            question: 'When do I take a used oil sample?',
            answer: `
            <p>Although the original equipment manufacturer's (OEM) recommendations provide a good starting point for developing preventative maintenance practices, sampling intervals can easily vary. Extreme conditions and applications can affect the sampling interval.  The completed oil analysis report can provide guidance on when a new sample should be taken. </p>
            `,
            weight: 1
        },
        {
            question: 'What information needs to be included with the sample?',
            answer: `
            <p>All customer, distributor, lubricant, and equipment information needs to be entered onto the sample label in order to process the sample. Include on the sample label if there was a lubricant or filter change during sampling. It is imperative that the sample label be applied directly to the plastic sample bottle, not the cardboard canister. The mailing label can be applied to the cardboard mailing canister or if using a box to send in more than one sample, it can be attached to the outside of the box and therefore, does not need to be applied to the canister.  Missing information from the sample label can result in a longer turn around time as the laboratory will need to request the information before the sample can be processed.</p>
            `,
            weight: 2
        },
        {
            question: 'How long does it take to process a sample?',
            answer: `
            <p>The laboratory processes most routine samples within 2-3 business days.  An Oil Analysis Report will be emailed to the customer contacts with recommendations or customers and distributors can access their reports through the website.  The website will show if the sample is completed or in process. If you do not receive your report within the 2-3 business days and the tracking number shows we received the sample, please call 1-800-637-8628 to inquire about the delay.</p>
            `,
            weight: 1
        },
        {
            question: 'Why do we need to run a cleaner or an additional fill of cleaner?',
            answer: `
            <p>A compressor cleaner is used to remove varnish, dirt, and oxidized fluid from a compressor. They are also used to flush a system when converting to a different lubricant to prevent contamination between the two different fluids.  A compressor cleaner has a short life, &lt;500, hours so additional fills of compressor cleaner could be needed depending on the cleanliness of the system. More varnished systems will require multiple fills of compressor cleaner.</p>
            `,
            weight: 1
        },
        {
            question: 'How long can I run a compressor cleaner?',
            answer: `
            <p>The maximum life of a compressor cleaner is 500 hours.  It is recommended to test the compressor cleaner every 200 hours to monitor the condition of the compressor cleaner.</p>
            `,
            weight: 1
        },
        {
            question: 'What is viscosity?',
            answer: `
            <p>Viscosity is a measure of a fluid’s resistance to flow.  It is one of the most important physical properties of a lubricant.  If a lubricant does not have the proper viscosity, it may not flow to the equipment parts that need protection, or have sufficient film thickness to provide adequate lubrication. Kinematic viscosity is the measure of a fluid’s resistance to flow under gravity at a specific temperature.</p>
            `,
            weight: 1
        },
        {
            question: 'What causes the viscosity to increase?',
            answer: `
            <p>The main cause for a fluid’s viscosity to increase is due to oxidation. Contamination and evaporation can also cause the viscosity to increase.  If the viscosity is too high it can result in:</p>
            <ul>
                <li>Increased flow resistance, preventing the lubricant from properly lubricating</li>
                <li>Increased temperature, which can promote oxidation and degradation of the lubricant</li>
                <li>An increase in power consumption.</li>
            </ul>
            `,
            weight: 2
        },
        {
            question: 'What causes the viscosity to decrease?',
            answer: `
            <p>Decreased viscosity can be caused by chemical ingestion, solvent contamination, or different fluid contamination.  If the viscosity is too low it can result in:</p>
            <ul>
                <li>Increased fluid leakage</li>
                <li>Increased wear because of metal-on-metal contact</li>
            </ul>
            `,
            weight: 2
        },
        {
            question: 'What causes the Total Acid Number to increase?',
            answer: `
            <p>The main cause for a fluid’s TAN to increase is oxidation.  Lubricant hydrolysis and contamination can also cause the TAN to increase. </p>
            `,
            weight: 1
        },
        {
            question: 'What is oxidation?',
            answer: `
            <p>Oxidation is a process that occurs when a lubricant is exposed to oxygen.  The negative effects of oxidation on an oil product include acid formation, sludge and varnish formation, increased viscosity, and lubricant decomposition. Since the major component of a lubricant, and base oil, is also the component that is most susceptible to oxidation, controlling this process is particularly important. A number of factors can accelerate the oxidation process, including increased temperatures and the presence in the lubricant of acids and metallic catalysts.  Two of the most common causes of accelerated lubricant oxidation are high operating temperatures and over-extension of the drain interval.  Oxidation stability is the ability to resist the oxidation process.  Oil with good oxidation stability will typically have a longer working life than an oil with poor stability, and may hold up better under extended drain operation conditions.</p>
            `,
            weight: 2
        },
        {
            question: 'What does it mean when the fluid has varnished?',
            answer: `
            <p>The by-products of oxidation can lead to the formation of a varnish contamination.  The varnish is what causes the smell of crayons.  There are many problems associated with fluid that has varnished but one of the main problems is increased component wear due to varnish attracting dirt and contaminant particles. There will also be increased maintenance costs due to cleanup and disposal of oil.</p>
            `,
            weight: 1
        },
        {
            question: 'Why is my antioxidant level below normal?',
            answer: `
            <p>Antioxidants are one of the primary additives used in lubricant formulations. The main function of the antioxidant is to prevent the lubricant from breaking down.  When a lubricant breaks down, it will typically result in polymerization or volatilization of the oil.  The antioxidant prevents this by reacting with the breakdown product of the lubricant to prevent further decomposition.  For this reason, the antioxidant level in a lubricant will drop with time or is considered sacrificial. An increase in Total Acid Number is a direct correlation to the depletion of antioxidants.</p>
            `,
            weight: 1.5
        },
        {
            question: 'Why is moisture content of a lubricant important?',
            answer: `
            <p>Moisture content of a lubricant is important as the presence of water, even at low levels, can:</p>
            <ul>
                <li>Reduce the efficiency and useable lifetime of lubricant additives, especially at elevated temperatures</li>
                <li>Contribute to premature corrosion and wear of bearings</li>
                <li>Support undesirable bacterial growth</li>
                <li>Reduce the load carrying ability of the lubricant</li>
                <li>React with the lubricant and some additives to form undesirable by-products (varnish, sludge, organic and inorganic acids).</li>
            </ul>
            `,
            weight: 2
        },
        {
            question: 'What does the ISO code mean for PC?',
            answer: `
            <p>The results formulate the ISO (International Standards Organization) code fraction.  The ISO code (i.e. 3/2/1) represents the ratio between particles present at levels greater than 4 micron (the denominator(1)) versus the particles present at levels greater than 6 micron (the middle number (2)) versus the particles present at levels greater than 14 micron (the numerator (3)).</p>
            `,
            weight: 1
        },
        {
            question: 'Why is the PC ISO code high when there are not metals present?',
            answer: `
            <p>The particle count test is counting metal particles and non-metallic particles.  Non-metallic particles could consist of water, dirt, or any solid material.  The particle count test can not distinguish from metallic and non-metallic particles.</p>
            `,
            weight: 1
        },
        {
            question: 'What is the difference between wear metals, contaminant metals, additive metals, and particles?',
            answer: `
            <p>Wear metals are minute particles of metal formed from the erosion between moving parts, abrasion, or corrosion.  Wear metals are related to surface interactions and more specifically the removal of material from a surface as a result of mechanical action.</p>
            <ul>
                <li>Three Types of Wear
                    <ul>
                        <li>Abrasion
                            <ul>
                                <li>Solid Contaminates-Sand (Silica)</li>
                            </ul>
                        </li>
                        <li>Corrosion
                            <ul>
                                <li>Water reacts with the metal surface</li>
                            </ul>
                        </li>
                        <li>Contact Fatigue
                            <ul>
                                <li>Metal to metal contact</li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
            <p>Contaminant metals cause the fluid to be impure.  These impurities can come from ground water, coolant, or another fluid type.</p>
            <p>Additive metals are any material added to a basestock which enhances the existing properties of the base oil and/or imparts new performance properties. Additives are used as antiwear agents, detergents, pour point depressants, rust and corrosion inhibitors, foam inhibitors, etc...</p>
            <p>Particles include metallic and non-metallic, fibers, dirt, water, bacteria and any other kind of debris.</p>
            `,
            weight: 5
        },
        {
            question: 'Where are the metals coming from?',
            answer: `
            <p>Common Sources of metals:</p>
            <ul>
                <li>Silver (Ag): bearing alloys</li>
                <li>Aluminum (Al): coolers/heat exchangers, bearings, bushings, pistons, blowers and pumps</li>
                <li>Copper (Cu):  heat exchangers, tubing, bearings, bronze/brass, bushings, and pistons</li>
                <li>Iron (Fe): bearings, cylinders, pumps, gears and motor walls</li>
                <li>Lead (Pb):  bearings</li>
                <li>Barium (Ba): lubricant additive</li>
                <li>Calcium (Ca): lubricant additive and ground water</li>
                <li>Sodium (Na): water, coolant</li>
                <li>Molybdenum (Mo):  steel, lubricant additive</li>
                <li>Magnesium (Mg): lubricant additive</li>
                <li>Phosphorus (P):  lubricant additive</li>
                <li>Silicon (Si): sand, dirt, seals, lubricant additive</li>
                <li>Zinc (Zn): galvanized parts, brass/bronze alloy, and lubricant additive</li>
            </ul>
            `,
            weight: 4
        }
    ]
}

export default faqConstants;



// WEBPACK FOOTER //
// ./web-app/constants/faqs.js